import React from "react";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { hasChromeText } from "./localReportChrome";
import { useRoundingFootnote } from "./useAmountScaleCaption";
import styles from "./AccountingReportFooter.module.scss";

interface Props {
    chrome: ReportPresentationChrome;
}

export const AccountingReportFooter: React.FC<Props> = ({ chrome }) => {
    const roundingFootnote = useRoundingFootnote();

    if (
        !roundingFootnote &&
        !hasChromeText(chrome.memo) &&
        !hasChromeText(chrome.footer)
    ) {
        return null;
    }

    return (
        <>
            {roundingFootnote && (
                <p className={styles.roundingFootnote}>{roundingFootnote}</p>
            )}
            {hasChromeText(chrome.memo) && (
                <p className={styles.memo}>{chrome.memo}</p>
            )}
            {hasChromeText(chrome.footer) && (
                <div className={styles.footer}>{chrome.footer}</div>
            )}
        </>
    );
};
